// Where a game is reviewed: `/review/{website}/{username}/{date}/{id}`. The
// id is what the screen looks the game up by; the website, username and
// date are there so the address says what it opens when it is shared. The
// date is informational and never parsed.
import type { GameSource, GameSummary } from '@chess/api-model';

/** The react-router pattern the review screen registers. */
export const REVIEW_ROUTE = '/review/:website/:username/:date/:id';

/** The route's parameters, as react-router hands them out. */
export interface ReviewRouteParams {
  website: string;
  username: string;
  date: string;
  id: string;
}

/** The website segment for a game's source: `chess.com` becomes `chesscom`. */
export function websiteOf(source: GameSource): string {
  return source.replace(/[^a-z0-9]/gi, '').toLowerCase();
}

/** The address a game is reviewed at. */
export function reviewPath(game: Pick<GameSummary, 'id' | 'owner' | 'source' | 'playedAt'>): string {
  const date = game.playedAt.slice(0, 10) || 'undated';
  return `/review/${websiteOf(game.source)}/${encodeURIComponent(game.owner)}/${date}/${encodeURIComponent(game.id)}`;
}
